import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import {
  migrateFontBoldStyleToFontWeightMutably,
  migrateUnifiedBulkActionsMutably,
  migrateUnifiedRowActionsMutably,
} from '../../../services/compat/migration.helpers';
import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const tableV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate table element to v2',
  run: (props: PartialPropsOf<'table'>): void => {
    const table = (props?.content?.table as any) || {};

    if ('allowAddingRows' in table) {
      const { allowAddingRows, addRowPage, addRowLabel } = table;
      props.content = {
        ...props.content,
        itemAdd: {
          enabled: allowAddingRows,
          targetId: addRowPage,
          targetType: 'Dialog',
          label: addRowLabel,
        },
      };
      delete table['allowAddingRows'];
      delete table['addRowPage'];
      delete table['addRowLabel'];
    }
    if ('allowEditingRows' in table) {
      const { allowEditingRows, editRowPage } = table;
      props.content = {
        ...props.content,
        itemEdit: {
          enabled: allowEditingRows,
          targetId: editRowPage,
          targetType: 'Dialog',
        },
      };
      delete table['allowEditingRows'];
      delete table['editRowPage'];
    }
    if ('allowDeletingRows' in table) {
      const { allowDeletingRows, deleteRowWorkflowId } = table;
      props.content = {
        ...props.content,
        itemDelete: {
          enabled: allowDeletingRows,
          targetId: deleteRowWorkflowId,
          targetType: 'Workflow',
        },
      };
      delete table['allowDeletingRows'];
      delete table['deleteRowWorkflowId'];
    }

    migrateUnifiedRowActionsMutably(props);

    migrateUnifiedBulkActionsMutably(props);

    migrateFontBoldStyleToFontWeightMutably(props?.style?.table?.group, '500', '400');
  },
};
